// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  kind: __t.string(),
  civ: __t.string(),
  label: __t.string(),
  stationKey: __t.string().name("station_key"),
  numbersJson: __t.string().name("numbers_json"),
  sourcesJson: __t.string().name("sources_json"),
  checkedAt: __t.timestamp().name("checked_at"),
});
